var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("COM_HeaderNav", { attrs: { mode: "onePageAdv" } }),
      _c("div", { staticClass: "form-group row" }, [
        _c("div", { staticClass: "col-sm-10" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-primary mybutton",
              staticStyle: { width: "100px" },
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.submit($event)
                }
              }
            },
            [_vm._v("儲存")]
          ),
          _c(
            "a",
            {
              staticClass: "btn btn-primary",
              attrs: { role: "button" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.switchMode()
                }
              }
            },
            [_vm._v(_vm._s(_vm.ModeText))]
          )
        ])
      ]),
      _c(
        "a",
        { staticClass: "btn btn-primary", on: { click: _vm.DataItem_AddLast } },
        [_c("i", { staticClass: "fas fa-plus-circle" })]
      ),
      _c(
        "table",
        { staticClass: "table table-hover", attrs: { id: "tblSecond" } },
        [
          _c("thead", { staticClass: "thead-light" }, [
            _c("tr", [
              _c("th", { staticClass: "text-center" }, [_vm._v("功能")]),
              _c("th", [_vm._v("名稱")]),
              _vm.ready && _vm.datas.UseCNameFeature
                ? _c("th", [_vm._v("網域CName (www等)")])
                : _vm._e(),
              _c("th", [_vm._v("是否顯示")]),
              _c("th", [_vm._v("說明")])
            ])
          ]),
          _c(
            "tbody",
            _vm._l(this.datas.Details, function(item, index) {
              return _c("tr", { key: index }, [
                _c("td", { staticStyle: { width: "300px" } }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.DataItem_Edit(item)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-pen" }), _vm._v("編輯頁面")]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-danger",
                      on: {
                        click: function($event) {
                          return _vm.DataItem_Remove(item)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-trash" })]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.DataItem_MoveUp(item)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-angle-up" })]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.DataItem_MoveDown(item)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-angle-down" })]
                  )
                ]),
                _c("td", { attrs: { width: "120px" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.Name,
                        expression: "item.Name"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "" },
                    domProps: { value: item.Name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(item, "Name", $event.target.value)
                      }
                    }
                  })
                ]),
                _c("td", { attrs: { width: "120px" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.CName,
                        expression: "item.CName"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "" },
                    domProps: { value: item.CName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(item, "CName", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm.ready && _vm.datas.UseCNameFeature
                  ? _c("td", { attrs: { width: "120px" } }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.IsVisible,
                              expression: "item.IsVisible"
                            }
                          ],
                          staticClass: "form-control",
                          staticStyle: { width: "100px" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                item,
                                "IsVisible",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { domProps: { value: true } }, [
                            _vm._v("顯示")
                          ]),
                          _c("option", { domProps: { value: false } }, [
                            _vm._v("隱藏")
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _c("td", { attrs: { width: "120px" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.Memo,
                        expression: "item.Memo"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "" },
                    domProps: { value: item.Memo },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(item, "Memo", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            }),
            0
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }